import { useTranslation } from "react-i18next";
import { useInView } from "@/hooks/useInView";

const GRID_ROWS = 4;
const GRID_COLS = 5;

const cellStates: number[][] = [
  [0, 0, 0, 0, 0],
  [0, 0, 1, 0, 0],
  [0, 1, 2, 1, 0],
  [0, 0, 1, 0, 0],
];

const colors = [
  "hsl(152 60% 54%)",
  "hsl(35 95% 55%)",
  "hsl(0 72% 55%)",
];

export function CropIntelligenceIllustration() {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  const legends = [
    t("landing.illustrations.low", "Low"),
    t("landing.illustrations.medium", "Medium"),
    t("landing.illustrations.high", "High"),
  ];

  return (
    <div ref={ref} className="rounded-2xl border border-landing-border bg-white p-6 shadow-soft">
      <p className="mb-4 text-sm font-semibold text-foreground">
        {t("landing.illustrations.pestPressureMap", "Pest Pressure Map")}
      </p>

      <div className="grid grid-cols-5 gap-2">
        {Array.from({ length: GRID_ROWS }).map((_, r) =>
          Array.from({ length: GRID_COLS }).map((_, c) => {
            const state = cellStates[r][c];
            const delay = (r * GRID_COLS + c) * 0.04;
            return (
              <div
                key={`${r}-${c}`}
                className="aspect-square rounded-lg transition-all duration-400"
                style={{
                  backgroundColor: colors[state],
                  opacity: inView ? 1 : 0,
                  transform: inView ? "scale(1)" : "scale(0.6)",
                  transitionDelay: `${delay}s`,
                }}
              />
            );
          })
        )}
      </div>

      <div className="mt-4 flex items-center gap-4 text-xs text-muted-foreground">
        {legends.map((label, i) => (
          <div key={label} className="flex items-center gap-1.5">
            <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: colors[i] }} />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
